/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/merklist-entry.ts.
 */
import {Artikel} from './artikel';
import {ImportHinweisOption} from './import-hinweis';

/**
 * Zweck: Beschreibt class MerklistEntry und ihren Daten- oder Funktionsvertrag.
 */
export class MerklistEntry {
  id: number;
  artikel: Artikel;
  note: string[];
  view_slug: string;
  menge = 1;
  freimenge = 0;
  aktionsrabattmenge = 0;
  naturalrabattmenge = 0;
  aktionsrabattprozent = 0;
  basisverrechnungspreis: number;

  dirty = false;
  valid = true;

  defect: boolean;

  gui_targetMenge = undefined;
  hatImportHinweisZugestimmt = false;
  importHinweisOption: ImportHinweisOption;
  importHinweisEntscheidung: 'confirm' | 'reduce';
  gui_importHinweisAbgelehnt = false;
}
